import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        <CardContent className="pt-12 pb-8 px-8">
          <div className="text-8xl font-bold text-gray-300 mb-4">404</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">{t('pageNotFound')}</h1>
          <p className="text-gray-500 mb-8">
            {t('notFoundDesc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/">
              <Button variant="outline" className="w-full sm:w-auto">
                <Home className="h-4 w-4 mr-2" />
                {t('home')}
              </Button>
            </Link>
            <Link to="/dashboard">
              <Button className="w-full sm:w-auto">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('dashboard')}
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
